import { useGetUserSession } from "@/lib/useQuery/user/useGetUserSession";
import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import * as Sentry from '@sentry/react';

export default function RedirectAuth({ to, requiresAuth = false }: { to: string, requiresAuth?: boolean }) {
    const { data: userSession, isLoading } = useGetUserSession();

    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (userSession?.user) {
            Sentry.withScope((scope) => {
                scope.setUser({
                    id: userSession.user.id,
                    email: userSession.user.email,
                    username: userSession.user.user_metadata.username,
                });
                scope.setTag("userId", userSession.user.id);
                scope.setContext("user", { ...userSession.user });
            });
        } else {
            Sentry.withScope((scope) => {
                scope.clear();
            });
        }
    }, [userSession]);
    useEffect(() => {
        if (isLoading) return;

        if (userSession && requiresAuth && (location.pathname !== "/account-setup") && (!userSession.user.user_metadata.first_name)) {
            navigate("/account-setup");
        } else if ((userSession && !requiresAuth) || (!userSession && requiresAuth)) {
            navigate(to);
        }
    }, [userSession, navigate, to, requiresAuth, isLoading, location.pathname]);

    return <Outlet />;
}
